import { render, staticRenderFns } from "./ImportStudent.vue?vue&type=template&id=3588314d&scoped=true"
import script from "./ImportStudent.vue?vue&type=script&lang=js"
export * from "./ImportStudent.vue?vue&type=script&lang=js"
import style0 from "./ImportStudent.vue?vue&type=style&index=0&id=3588314d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588314d",
  null
  
)

export default component.exports